import { render, staticRenderFns } from "./MyPatentOperationList.vue?vue&type=template&id=3a792d6e&scoped=true"
import script from "./MyPatentOperationList.vue?vue&type=script&lang=ts"
export * from "./MyPatentOperationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a792d6e",
  null
  
)

export default component.exports